jQuery(function() {
    if($('.sustainability-overview').length>0){
        $('body').addClass('cmo-sustainability-page');
    }
    if($('.cmo-sustainability-page #front-hero').length>0){
        $('.cmo-sustainability-page #front-hero').siblings('p').hide();
    }
});

